import logo from '../assets/Nimbus_logo_only.png';
import logoName from '../assets/Nimbus_logo_name.png';

function LoginLogo({ showFullLogo }) {
  return (
    <>
      <div style={styles.logoContainer}>
        <img
          src={logo}
          alt="Nimbus Logo"
          style={styles.logo}
          className={showFullLogo ? 'logo-move' : 'logo-bounce'}
        />
        {showFullLogo && (
          <img
            src={logoName}
            alt="Nimbus Logo Name"
            style={styles.logoName}
            className="logo-name-slide"
          />
        )}
      </div>

      <style>{`
        @keyframes logoBounce {
          0% {
            top: -300px;
            transform: translate(-50%, -50%) scale(1.5);
            animation-timing-function: cubic-bezier(0.1, 0, 0.9, 1);
          }
          25% {
            top: 40vh;
            transform: translate(-50%, -50%) scale(1.5);
            animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
          }
          50% {
            top: 10vh;
            transform: translate(-50%, -50%) scale(1.5);
            animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
          }
          80% {
            top: 40vh;
            transform: translate(-50%, -50%) scale(1.5);
            animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
          }
          100% {
            top: 5vh;
            transform: translate(-50%, -50%) scale(1);
            animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
          }
        }

        @keyframes slideInName {
          0% {
            opacity: 0;
            top: 5vh;
            left: 50%;
            transform: translate(-50%, -50%) scale(1);
          }
          100% {
            opacity: 1;
            top: 5vh;
            left: calc(50% + 55px);
            transform: translate(-50%, -50%) scale(1);
          }
        }

        @keyframes moveLogo {
          0% {
            top: 5vh;
            left: 50%;
            transform: translate(-50%, -50%) scale(1);
          }
          100% {
            top: 5vh;
            left: calc(50% - 105px);
            transform: translate(-50%, -50%) scale(1);
          }
        }

        .logo-bounce {
          animation: logoBounce 3.5s ease-out forwards;
        }

        .logo-move {
          animation: moveLogo 1.5s ease-out forwards;
        }

        .logo-name-slide {
          animation: slideInName 1.5s ease-out forwards;
        }
      `}</style>
    </>
  );
}

const styles = {
  logoContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '50px',
    marginTop: '0rem',
  },
  logo: {
    width: '100px',
    position: 'absolute',
    left: '50%',
    top: '5vh',
    transform: 'translate(-50%, -50%) scale(1)',
    zIndex: 1,
  },
  logoName: {
    position: 'absolute',
    left: '50%',
    top: '5vh',
    transform: 'translate(-50%, -50%) scale(1)',
    opacity: 0,
    width: '200px',
    height: 'auto',
    zIndex: 0,
  },
};

export default LoginLogo;
